export function sanitizeFileName(fileName, random = true) {


    return fileName?.substring(0, fileName?.lastIndexOf('.'))?.replace(/[^a-z0-9]/gi, '_').toLowerCase() + fileName?.substring(fileName?.lastIndexOf('.'));
}